/** bookingsTabsKeyboard — pure roving-tabindex arrow-key math for the
 *  Bookings tablist (BON-490). Kept DOM-free so the wrap-around logic is
 *  unit-testable without mounting anything. */
export type TabNavKey = 'ArrowLeft' | 'ArrowRight' | 'Home' | 'End';

export function isTabNavKey(key: string): key is TabNavKey {
  return key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Home' || key === 'End';
}

/** The next tab index for a roving-tabindex tablist, wrapping at both ends. */
export function nextTabIndex(key: TabNavKey, currentIndex: number, length: number): number {
  switch (key) {
    case 'ArrowRight':
      return (currentIndex + 1) % length;
    case 'ArrowLeft':
      return (currentIndex - 1 + length) % length;
    case 'Home':
      return 0;
    case 'End':
      return length - 1;
  }
}
